// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vehicle[data-v-4798768a] {\n  background: #EEEDEC;\n  padding: 20px;\n}\n.vehicle .plate-number[data-v-4798768a] {\n  font-size: 22px;\n}", ""]);
// Exports
module.exports = exports;
